export default "__VITE_ASSET__Bu3qvluv__";